namespace $ {

	export function $mol_fail( error : any ) : never {
		throw error
	}

}
